export default __webpack_public_path__ + "static/media/information.b5944b4c.png";